import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";

export default function FeedbackButtons({
  selectedRating,
  disabled = false,
  onSelect,
  onSelectedClick,
  selectedTooltip = "",
}) {
  const isGoodSelected = selectedRating === "Good";
  const isBadSelected = selectedRating === "Bad";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {!isGoodSelected && !isBadSelected && (
        <>
          <span>
            <IconButton
              size="small"
              onClick={() => onSelect("Good")}
              disabled={disabled}
              sx={{
                color: "rgba(255,255,255,0.7)",
              }}
            >
              <ThumbUpOffAltIcon fontSize="small" />
            </IconButton>
          </span>

          <span>
            <IconButton
              size="small"
              onClick={() => onSelect("Bad")}
              disabled={disabled}
              sx={{
                color: "rgba(255,255,255,0.7)",
              }}
            >
              <ThumbDownOffAltIcon fontSize="small" />
            </IconButton>
          </span>
        </>
      )}

    
      {isGoodSelected && (
        <Tooltip title={selectedTooltip}>
          <span>
            <IconButton
              size="small"
              onClick={() => (onSelectedClick ? onSelectedClick() : onSelect(null))}
              disabled={disabled}
              sx={{
                color: "#7CFC98",
                backgroundColor: "rgba(124, 252, 152, 0.14)",
                border: "1px solid rgba(124, 252, 152, 0.35)",
              }}
            >
              <ThumbUpOffAltIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}

    
      {isBadSelected && (
        <Tooltip title={selectedTooltip}>
          <span>
            <IconButton
              size="small"
              onClick={() => (onSelectedClick ? onSelectedClick() : onSelect(null))}
              disabled={disabled}
              sx={{
                color: "#FF9A9A",
              }}
            >
              <ThumbDownOffAltIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
